/*
 * @Description:
 * @Author: zhanglu
 * @Date: 2020-11-05 19:44:56
 * @LastEditors: lidan
 * @LastEditTime: 2021-02-01 15:44:41
 */
import http from "e6-base-core/axios/config";
import { e6ModuleSettleAccountsCenterApi } from "@/config/api";
const {
  host,
  E6_MS_TMS_BASE_WEB,
  E6_MS_TMS_FINANCIAL_WEB,
  COMMON_MODULE_BASE_FILE_PROCESSOR_WEB
} = e6ModuleSettleAccountsCenterApi;

//********************* 对客户结算 ****************** */
// header
export function fetchHeader(id) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/check/getField/${id}`,
    method: "get"
  });
}
// 获取客户下拉
export function fetchCustomerList(data) {
  return http({
    url: `${host}${E6_MS_TMS_BASE_WEB}/customerCarrier/listCustomerCarrierByPage`,
    method: "post",
    data
  });
}
//********************* list页面 ****************** */
// list - 获取列表数据
export function fetchTable(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/check/getBillByPage`,
    method: "post",
    data
  });
}
// 账单删除
export function deleteBill(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/check/deleteBill`,
    method: "post",
    data
  });
}
// 发送账单
export function sendBill(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/check/sendBill`,
    method: "post",
    data
  });
}
// 收票确认
export function receiveInvoice(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/check/receiveInvoice`,
    method: "post",
    data
  });
}
// 支付确认
export function confirmPlay(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/check/confirmPlay`,
    method: "post",
    data
  });
}
// 发票确认
export function sendInvoice(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/check/sendInvoice`,
    method: "post",
    data
  });
}
// 核销确认
export function confirmCancel(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/check/confirmCancel`,
    method: "post",
    data
  });
}
// 账单导出
export function exportBill(data) {
  return http({
    headers: { "Content-Type": "application/json" },
    responseType: "blob",
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/check/exportBill`,
    method: "post",
    data
  });
}
//********************* 生成账单 ****************** */
// list - 获取列表数据
export function fetchCreateBillTable(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/check/getAccruedCostByPage`,
    method: "post",
    data
  });
}
// 生成账单
export function createBill(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/check/createBill`,
    method: "post",
    data
  });
}
// 全部生成账单
export function createAllBill(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/check/createAllBill`,
    method: "post",
    data
  });
}
//********************* 调整金额 ****************** */
// list - 获取列表数据
export function fetchAdjustAmountTable(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/check/getBillAdjustByPage`,
    method: "post",
    data
  });
}
// 整体调整
export function saveAllAdjust(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/check/saveAllRecord`,
    method: "post",
    data
  });
}
// 账单信息
export function fetchBillInfo(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/check/getBillById`,
    method: "post",
    data
  });
}

/* ******************** 账单确认 ****************** */

// 账单确认列表
export function getBillConfirmByPage(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/check/getBillConfirmByPage`,
    method: "post",
    data
  });
}
// 账单确认
export function confirmBill(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/check/confirmBill`,
    method: "post",
    data
  });
}
// 账单确认
export function newConfirmBill(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/check/newConfirmBill`,
    method: "post",
    data
  });
}
//********************* 账单详情 ****************** */
// 账单事件
export function getEventRecord(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/check/getEventRecord`,
    method: "post",
    data
  });
}
//********************* 导入对账数据 ****************** */
// 导入客户对账数据
export function importParseFile(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/check/importCustomerParseFile`,
    method: "post",
    data
  });
}
// 导入调整
export function importGetField(params) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/check/getImportField`,
    method: "get",
    params
  });
}
// 导入数据提交
export function importBillData(data) {
  return http({
    url: `${host}${E6_MS_TMS_FINANCIAL_WEB}/check/importBillData`,
    method: "post",
    data
  });
}
// 获取上传中心模块初始化数据
export function getUploadCenterInitInfo(params) {
  return http({
    url: `${host}${COMMON_MODULE_BASE_FILE_PROCESSOR_WEB}/importCenter/import/getTemplate`,
    method: "get",
    params
  });
}
